export const SECTION_NAME = {
  PAYMENT_METHOD: 'PAYMENT_METHOD',
  SHIPPING_INFO: 'SHIPPING_INFO',
  BILLING_INFO: 'BILLING_INFO',
  SUMMARY: 'SUMMARY',
  PAYMENT_DETAILS: 'PAYMENT_DETAILS',
};
